module.exports = __webpack_public_path__ + "static/media/Lays_thumbnail.39435b22.png";